module Shared {
    export class NAVNationality {
        code: string = null;
        name: string = null;
        nationality: string = null;
    }
}